import React, { useState, useEffect } from "react"
import dynamic from "next/dynamic"
import { Layout } from "components/common"
import { Loading } from "components/ui"
import "react-datepicker/dist/react-datepicker.css"
import Cookies from "js-cookie"
import cn from "classnames"
import s from "./../components/Ranking/BoxMatchRanking/BoxMatchRanking.module.css"
import Dropdown from "components/Dropdown"

const BoxMatchRanking = dynamic(() => import("components/Ranking/BoxMatchRanking"), { ssr: false })
const BoxMatchRankingMobile = dynamic(() => import("components/Ranking/BoxMatchRanking/BoxMatchRankingMobile"), {
  ssr: false
})
const BoxProgramRules = dynamic(() => import("components/Ranking/BoxProgramRules"), { ssr: false })
const BoxProgramRulesMobile = dynamic(() => import("components/Ranking/BoxProgramRules/BoxProgramRulesMobile"), {
  ssr: false
})
const BoxGuideGame = dynamic(() => import("components/Ranking/BoxGuideGame"), { ssr: false })
const BoxGuideGameMobile = dynamic(() => import("components/Ranking/BoxGuideGame/BoxGuideGameMobile"), { ssr: false })
const BoxGetGift = dynamic(() => import("components/Ranking/BoxGetGift"), { ssr: false })
const BoxGetGiftMobile = dynamic(() => import("components/Ranking/BoxGetGift/BoxGetGiftMobile"), { ssr: false })

export default function LiveScore() {
  const [checkShow, setCheckShow] = useState(1)
  const [isMobile, setIsMobile] = useState(false)

  const listFunc = [
    {
      name: "Bảng xếp hạng",
      logo: "https://stvinaprod.vtvcab.vn/00eb5ea6-2d4e-4730-94a4-3d8befdf0434.png",
      id: 1
    },
    {
      name: "Thể lệ chương trình",
      logo: "https://stvinaprod.vtvcab.vn/00dd312e-3454-46c8-9fd1-60f328ff9690.png",
      id: 2
    },
    {
      name: "Hướng dẫn chơi",
      logo: "https://stvinaprod.vtvcab.vn/fa7fe61b-7b35-4607-9950-6df6538cf7a2.png",
      id: 3
    },
    {
      name: "Liên hệ nhận thưởng",
      logo: "https://stvinaprod.vtvcab.vn/83101771-72b3-4f77-9f2b-a3489924e754.png",
      id: 4
    }
  ]

  function onchangeMenu(id) {
    setCheckShow(id)
  }
  async function fetch() {}

  useEffect(() => {
    const date = Cookies.get("date")
    const __d = date ? new Date(date) : new Date()
    fetch(__d)
  }, [])

  useEffect(() => {
    if (window.innerWidth < 767) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  return (
    <div>
      {isMobile === false && (
        <div className="grid grid-cols-12 gap-4 max-w-screen-2xl m-auto p-4 mb-8">
          <div className="col-span-2 my-4">
            <img
              src="https://stvinadev.vtvcab.vn/f8d47ed1-f68e-4746-92c0-692af3c663aa.png"
              width={239}
              height={271}
              alt="stvinaprod"
            ></img>
            <div className="mt-6">
              {listFunc.map((item, k) => {
                return (
                  <button className="mt-0.5 mb-0.5 w-full gap-5" key={k} onClick={() => onchangeMenu(item?.id)}>
                    <div
                      className={cn("bg-dark rounded-lg", {
                        [s.active]: checkShow === k + 1
                      })}
                    >
                      <div className=" flex items-center p-2 justify-start">
                        <span className="pl-3 py-1">
                          <img src={item?.logo} alt="" width="32" height="32"></img>
                        </span>
                        <span className="font-normal text-sm text-dark-300 pl-4">{item?.name}</span>
                      </div>
                    </div>
                  </button>
                )
              })}
            </div>
          </div>

          <div className="col-span-10 text-dark-300 relative px-4 py-4">
            <Loading>
              {checkShow === 1 && <BoxMatchRanking fetch={fetch} />}
              {checkShow === 2 && <BoxProgramRules fetch={fetch} />}
              {checkShow === 3 && <BoxGuideGame fetch={fetch} />}
              {checkShow === 4 && <BoxGetGift fetch={fetch} />}
            </Loading>
          </div>
        </div>
      )}
      {/* Mobile */}
      {isMobile === true && (
        <div className="grid grid-cols-12 gap-4 m-auto p-4">
          <div className="col-span-12">
            <img src="https://stvinadev.vtvcab.vn/e1db9a20-7468-4575-a435-6335121bf98e.png" alt="stvinaprod"></img>

            <div className="mt-6">
              <Dropdown menus={listFunc} onChange={onchangeMenu}></Dropdown>
            </div>
          </div>

          <div className="col-span-12 text-dark-300 relative ">
            <Loading>
              {checkShow === 1 && <BoxMatchRankingMobile fetch={fetch} />}
              {checkShow === 2 && <BoxProgramRulesMobile fetch={fetch} />}
              {checkShow === 3 && <BoxGuideGameMobile fetch={fetch} />}
              {checkShow === 4 && <BoxGetGiftMobile fetch={fetch} />}
            </Loading>
          </div>
        </div>
      )}
    </div>
  )
}

LiveScore.Layout = Layout
